import { AUTH_STORAGE } from './storageConfig'

type StorageAuthTokenProps = {
  accessToken: string
  refreshToken: string
}

export function storageAuthTokenSave ({ accessToken, refreshToken }: StorageAuthTokenProps) {
  localStorage.setItem(
    AUTH_STORAGE,
    JSON.stringify({ accessToken, refreshToken })
  )
}

export function storageAuthTokenGet () {
  const response = localStorage.getItem(AUTH_STORAGE)

  const { accessToken, refreshToken }: StorageAuthTokenProps = response
    ? JSON.parse(response)
    : {}

  return { accessToken, refreshToken }
}

export function storageAuthTokenRemove () {
  localStorage.removeItem(AUTH_STORAGE)
}
